import React from "react";
import { previewKind } from "../model/complianceRules";
import { previewStyles as styles } from "./complianceStyles";

function PreviewContent({ preview }) {
    const kind = previewKind(preview);
    if (kind === "image") {
        return (
            <div style={styles.imageFrame}>
                <img src={preview.url} alt={preview.fileName} style={styles.image} />
            </div>
        );
    }
    if (kind === "audio") {
        return (
            <div style={styles.audioFrame}>
                <audio controls src={preview.url} style={styles.audio}>
                    Votre navigateur ne peut pas lire ce fichier audio.
                </audio>
            </div>
        );
    }
    if (kind === "video") {
        return (
            <video controls src={preview.url} style={styles.video}>
                Votre navigateur ne peut pas lire cette vidéo.
            </video>
        );
    }
    if (kind === "inline") {
        return <iframe title={preview.fileName} src={preview.url} style={styles.inline} />;
    }
    return (
        <div style={styles.unavailable}>
            <strong style={styles.unavailableTitle}>Aperçu non disponible</strong>
            <span style={styles.unavailableText}>
                Ce format ne peut pas être affiché directement par le navigateur. Le fichier reste accessible depuis la plateforme.
            </span>
            <a href={preview.url} download={preview.fileName} style={styles.unavailableDownload}>
                Télécharger le fichier
            </a>
        </div>
    );
}

export default function FilePreviewModal({ preview, onClose }) {
    return (
        <div style={styles.overlay}>
            <div style={styles.dialog}>
                <div style={styles.header}>
                    <strong style={styles.title}>
                        {preview.fileName}
                    </strong>
                    <div style={styles.headerActions}>
                        <a href={preview.url} download={preview.fileName} style={styles.download}>
                            Télécharger
                        </a>
                        <button type="button" onClick={onClose} style={styles.close}>
                            Fermer
                        </button>
                    </div>
                </div>
                <div style={styles.body}>
                    <PreviewContent preview={preview} />
                </div>
            </div>
        </div>
    );
}
